import React, { ComponentType } from 'react'

import { useHandler } from '@surglogs-app/hooks'

import { UsePromptOpts, usePrompt } from './usePrompt'

export interface ModalProps {
  hideModal: () => void
  [prop: string]: any
}

export const useModal = <
  TModalProps extends ModalProps,
  TModal extends ComponentType<TModalProps>,
>(
  Modal: TModal extends ComponentType<TModalProps>
    ? TModal
    : ComponentType<Partial<TModalProps>>,
  opts?: UsePromptOpts,
) => {
  // type CP = ComponentPropsWithoutRef<typeof Modal>
  // type CC = Exclude<keyof TModalProps, keyof CP>

  const [prompt, prompting, id] = usePrompt(opts)
  const show = useHandler((props?: Partial<Omit<TModalProps, 'hideModal'>>) =>
    prompt(({ answer }) => (
      <Modal {...(props as any)} {...{ hideModal: answer }} />
    )),
  )
  return [show, prompting, id] as const
}
